import { DateRangeType } from '../../../types/phlebotomist-dashboard';
import { VALID_DATE_RANGES } from '../constants';

export interface IRecruiterFilters {
  dateRange: DateRangeType;
  customDateRange?: { start: Date; end: Date };
  regionIds: string[];
  officeIds: string[];
  locationIds: string[];
}

export const DEFAULT_RECRUITER_FILTERS: IRecruiterFilters = {
  dateRange: 'monthCal',
  regionIds: [],
  officeIds: [],
  locationIds: [],
};

export function recruiterFiltersFromUrl(
  searchParams: URLSearchParams
): IRecruiterFilters {
  const base: IRecruiterFilters = { ...DEFAULT_RECRUITER_FILTERS };

  const dr = searchParams.get('dateRange');
  if (dr && VALID_DATE_RANGES.has(dr)) base.dateRange = dr as DateRangeType;

  const cs = searchParams.get('customStart');
  const ce = searchParams.get('customEnd');
  if (cs && ce && base.dateRange === 'custom') {
    const start = new Date(cs);
    const end = new Date(ce);
    if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
      base.customDateRange = { start, end };
    }
  }

  const rIds = searchParams.get('regionIds');
  if (rIds !== null) base.regionIds = rIds ? rIds.split(',') : [];

  const oIds = searchParams.get('officeIds');
  if (oIds !== null) base.officeIds = oIds ? oIds.split(',') : [];

  const loc = searchParams.get('locationIds');
  if (loc) base.locationIds = loc.split(',');

  return base;
}

export function recruiterFiltersToUrl(
  filters: IRecruiterFilters
): URLSearchParams {
  const params = new URLSearchParams();

  if (filters.dateRange !== DEFAULT_RECRUITER_FILTERS.dateRange) {
    params.set('dateRange', filters.dateRange);
  }
  if (filters.dateRange === 'custom' && filters.customDateRange) {
    params.set('customStart', filters.customDateRange.start.toISOString());
    params.set('customEnd', filters.customDateRange.end.toISOString());
  }
  if (filters.regionIds.length > 0) {
    params.set('regionIds', filters.regionIds.join(','));
  }
  if (filters.officeIds.length > 0) {
    params.set('officeIds', filters.officeIds.join(','));
  }
  if (filters.locationIds.length > 0) {
    params.set('locationIds', filters.locationIds.join(','));
  }

  return params;
}
